var mpdParser = require('mpd-parser');
import Rendition from './../Resource/Rendition';
import Segment from './../Resource/Segment';
export default class DashParser {
    static parse(url, textData, resource) {
        const rawManifest = textData;
        let parsedManifest = mpdParser.parse(rawManifest, { url });
        let playlists = parsedManifest.playlists;
        for (var playlist of playlists) {
            let rendition = new Rendition();
            rendition.bandwidth = playlist.attributes.BANDWIDTH;
            rendition.uri = playlist.resolvedUri;
            let renditionKey = rendition.uri;
            if (!rendition.uri || rendition.uri == '') {
                renditionKey = playlist.attributes;
            }
            resource.addRendition(renditionKey, rendition);
            for (var segment of playlist.segments) {
                let newSegment = new Segment();
                let uri = segment.uri;
                while (uri.startsWith("../")) {
                    uri = uri.replace("../", "");
                }
                newSegment.uri = uri;
                rendition.segments.set(segment.resolvedUri, newSegment);
            }
            resource.addRendition(rendition.uri, rendition);
        }
        ;
        //  console.log( resource );
    }
}
//let uri = "https://bitmovin-a.akamaihd.net/content/MI201109210084_1/mpds/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.mpd";
//let uri = "https://akamaibroadcasteruseast.akamaized.net/cmaf/live/657078/akasource/out.mpd";
//let dashParser = new DashParser(uri);
//dashParser.load(uri);
//console.log( parsed );
//console.log("Hola");
